import { colors } from 'theme/colors';

export function getCommonProps(isDisabled: boolean) {
  return {
    disabled: isDisabled,
    isDisabled: isDisabled,
    opacity: '1 !important',
    focusBorderColor: colors.brand[800],
  };
}
